import shave from "shave"

// Header search input styles logic
const headerSearchContainer = document.querySelector(".help-center-header__search")
const headerSearchInput = document.querySelector("#header-search")
const headerSearchBtn = document.querySelector(".header-search-btn")
const headerSearchClearBtn = document.querySelector(".header-search-clear")
const moreButton = document.querySelector(".help-center__article-aside-load-more")
// eslint-disable-next-line
const $desktopView = 1368
const $tabletView = 960
const $mobileView = 640
const $mediumMobileView = 480
const $smallestMobileView = 320

headerSearchInput.addEventListener("focus", () => {
    if (window.innerWidth < 620) {
        headerSearchContainer.classList.add("show-header-search")
    }
})
headerSearchInput.addEventListener("blur", () => {
    if (window.innerWidth < 620 && !headerSearchInput.value) {
        headerSearchContainer.classList.remove("show-header-search")
    }
})
headerSearchInput.addEventListener("input", event => {
    if (event.target.value) {
        headerSearchBtn.classList.add("hide")
        headerSearchClearBtn.classList.remove("hide")
    } else {
        headerSearchBtn.classList.remove("hide")
        headerSearchClearBtn.classList.add("hide")
    }
})
headerSearchClearBtn.addEventListener("click", () => {
    headerSearchInput.value = null
    headerSearchBtn.classList.remove("hide")
    headerSearchClearBtn.classList.add("hide")
})
window.addEventListener("resize", () => {
    if (window.innerWidth < 620 && headerSearchInput.value) {
        headerSearchContainer.classList.add("show-header-search")
    }

    if (window.innerWidth >= 620) {
        headerSearchContainer.classList.remove("show-header-search")
    }
})

//Search
const pageSearchInput = document.querySelector("#page-search")
const pageSearchBtn = document.querySelector("#page-search-btn")

function search(query) {
    window.location = `/help-center/search?query=${query}`
}
function searchOnEnter(event) {
    if (event.keyCode === 13 && event.target.value) search(event.target.value)
}
function searchOnClick() {
    if (pageSearchInput.value) search(pageSearchInput.value)
}
// Header search
headerSearchInput.addEventListener("keypress", searchOnEnter)
// Page search
if (pageSearchInput) {
    pageSearchBtn.addEventListener("click", searchOnClick)
    pageSearchInput.addEventListener("keypress", searchOnEnter)
}

// Main page slider
const articlesSlider = document.querySelector("#articlesSlider")
if (articlesSlider) {
    // Show slider smoothly to hide initialization process
    articlesSlider.classList.remove("zero-opacity")

    // Get translation key for card description 'more...' text
    const cardDescMoreText = articlesSlider.dataset.moreKey

    // Add default slider values
    const maxDesktopSliderWidth = 1266
    const desktopPadding = 38
    const tabletPadding = 30
    // eslint-disable-next-line
    const mobilePadding = 20
    // eslint-disable-next-line
    const smallMobilePadding = 10
    let sliderWidth = maxDesktopSliderWidth

    let activeSlideIndex = 0
    let isTransitionAdded = false
    // Init slider
    // eslint-disable-next-line
    const swiper = new Swiper("#articlesSlider", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: false,
        width: sliderWidth,
        breakpoints: {
            1366: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: false
            },
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
                centeredSlides: false
            }
        }
    })

    // Count slider width depending on window width right after slider init
    resizeSliderWidth(true)

    // Count slider width on window resize
    window.addEventListener("resize", resizeSliderWidth)

    // Detect slide click outside of active slides
    sliderClick()

    // Update slider width on window width change
    // eslint-disable-next-line no-inner-declarations
    function resizeSliderWidth(update = false) {
        // Full desktop window width
        if (window.innerWidth > maxDesktopSliderWidth + desktopPadding * 2) {
            sliderWidth = maxDesktopSliderWidth
            swiper.params.width = sliderWidth
        }
        // Medium desktop before tablet window width
        else if (window.innerWidth <= maxDesktopSliderWidth + desktopPadding * 2 && window.innerWidth > $tabletView) {
            sliderWidth = window.innerWidth - desktopPadding * 2
            swiper.params.width = sliderWidth
        }
        // Tablet window width
        else if (window.innerWidth <= $tabletView && window.innerWidth > $mobileView) {
            sliderWidth = window.innerWidth - tabletPadding * 2
            swiper.params.width = sliderWidth
        }
        // Mobile window width
        else if (window.innerWidth <= $mobileView && window.innerWidth > $mediumMobileView) {
            sliderWidth = window.innerWidth - window.innerWidth * 0.18 * 2
            swiper.params.width = sliderWidth
        }
        // Medium mobile window width
        else if (window.innerWidth <= $mediumMobileView && window.innerWidth > $smallestMobileView) {
            sliderWidth = window.innerWidth - window.innerWidth * 0.12 * 2
            swiper.params.width = sliderWidth
        }
        // Small mobile window width
        else if (window.innerWidth <= $smallestMobileView) {
            sliderWidth = window.innerWidth - window.innerWidth * 0.1 * 2
            swiper.params.width = sliderWidth
        }

        if (update) swiper.update()
        // Update description 'more...' text
        addMoreToCardDesc()
        // Update slides classes
        slideChange()
    }

    // Detect a click on a slide
    // eslint-disable-next-line no-inner-declarations
    function sliderClick() {
        const slides = [...document.querySelectorAll(".swiper-slide")]

        slides.forEach((slide, index) => {
            slide.addEventListener("click", event => {
                const slidesPerView = detectSlidesPerView()
                // Don't allow to go to a slide link if situates before active slide
                if (index < activeSlideIndex) event.preventDefault()
                // Move slides to left on click on a slide situated on the right side of active slides
                if (index > activeSlideIndex + slidesPerView - 1) {
                    event.preventDefault()
                    swiper.slideNext()
                }
            })
        })
    }

    // Add/remove slider opacity on slide change
    // eslint-disable-next-line no-inner-declarations
    function slideChange() {
        // Find all slides
        const swiperSlides = [...document.querySelectorAll(".swiper-slide")]

        // Add transition style to each slide only after slider init
        // and if transition hasn't been added before
        if (swiper && !isTransitionAdded) {
            swiperSlides.forEach(slide => addTransitionToEachSlide(slide))
            isTransitionAdded = true
        }

        // Detect active slide index only after slider init
        if (swiper) activeSlideIndex = swiper.activeIndex

        let count = detectSlidesPerView()

        // Add/remove slide opacity depending on window width
        switch (count) {
            case 2:
                return swiperSlides.forEach((slide, index) => {
                    index === activeSlideIndex || index === activeSlideIndex + 1
                        ? slide.classList.remove("swiper-slide_disabled")
                        : slide.classList.add("swiper-slide_disabled")
                })
            case 1:
                return swiperSlides.forEach((slide, index) => {
                    index === activeSlideIndex
                        ? slide.classList.remove("swiper-slide_disabled")
                        : slide.classList.add("swiper-slide_disabled")
                })
            default:
                return swiperSlides.forEach((slide, index) => {
                    index === activeSlideIndex || index === activeSlideIndex + 1 || index === activeSlideIndex + 2
                        ? slide.classList.remove("swiper-slide_disabled")
                        : slide.classList.add("swiper-slide_disabled")
                })
        }
    }

    // Add transition to specified slide
    // eslint-disable-next-line no-inner-declarations
    function addTransitionToEachSlide(slide) {
        slide.classList.add("swipe-transition")
    }

    // Adding 'more...' to card description logic
    // eslint-disable-next-line no-inner-declarations
    function addMoreToCardDesc() {
        let titleMargin, minDescHeight
        window.innerWidth > 320 ? (titleMargin = 20) : (titleMargin = 10)
        window.innerWidth > 480 ? (minDescHeight = 14) : (minDescHeight = 13)

        const slides = [...document.querySelectorAll(".swiper-slide")]

        slides.forEach((slide, index) => {
            const cardDesc = slide.querySelector(".help-center__slider-card-desc")
            const cardInnerHeight = slide.querySelector(".help-center__slider-card").offsetHeight
            const cardTitleHeight = slide.querySelector(".help-center__slider-card-title").offsetHeight
            const cardDescHeight = cardInnerHeight - cardTitleHeight - titleMargin

            if (cardDescHeight >= minDescHeight) {
                // Show description if there is enough space for the block
                if (cardDesc.classList.contains("none")) {
                    cardDesc.classList.remove("none")
                }
                // Add truncation and 'more...' at the end
                shave(`#slideDesc-${index}`, cardDescHeight, { character: cardDescMoreText })
            } else {
                // Hide description if there is no space for the block
                if (!cardDesc.classList.contains("none")) {
                    cardDesc.classList.add("none")
                }
            }
        })
    }

    // Detect slides per view
    // eslint-disable-next-line
    function detectSlidesPerView() {
        let count
        if (window.innerWidth > $tabletView) {
            count = 3
        } else if (window.innerWidth <= $tabletView && window.innerWidth > $mobileView) {
            count = 2
        } else if (window.innerWidth <= $mobileView) {
            count = 1
        }

        return count
    }
}

// Categories and subcategories accordion logic
const categoriesContainer = document.querySelector(".help-center__categories")
const subcategoriesContainer = document.querySelector(".help-center__subcategories")

if (categoriesContainer || subcategoriesContainer) {
    const categories = document.querySelectorAll(".help-center__category")
    const subcategories = document.querySelectorAll(".help-center__subcategory")

    // Leave first category open by default
    let firstContentBox, openCategoryId
    if (categoriesContainer) {
        firstContentBox = categories[0].querySelector(".help-center__category-content")
        firstContentBox.style.maxHeight = firstContentBox.scrollHeight + "px"
        openCategoryId = categories[0].id
    }

    // Adding listeners to every category/subcategory item
    // eslint-disable-next-line
    function addListeners(items, itemName) {
        for (let i = 0; i < items.length; i++) {
            items[i].addEventListener("click", function (event) {
                // Prevent closing category if click not on a head
                if (!event.target.closest(`.help-center__${itemName}-head`)) return

                // Close previously open category after clicking on a new one
                if (itemName === "category") {
                    // Close all open subcategories after clicking on category second time
                    if (openCategoryId === items[i].id) {
                        closeSubcategories(items[i])
                    }
                    // Click on a new category
                    else if (openCategoryId && openCategoryId !== items[i].id) {
                        const categoryItem = [...items].find(item => item.id === openCategoryId)
                        handleItemView(itemName, categoryItem)
                        openCategoryId = null

                        // Close all subcategories inside previously open category after clicking on a new category
                        closeSubcategories(categoryItem)
                    }
                    openCategoryId = items[i].id
                }

                // Handle opening/closing item depending on block max-height availability
                const content = items[i].querySelector(`.help-center__${itemName}-content`)
                content.style.maxHeight ? handleItemView(itemName, items[i]) : handleItemView(itemName, items[i], true)
            })
        }
    }
    // Start logic for all accordion head items
    if (categoriesContainer) addListeners(categories, "category")
    addListeners(subcategories, "subcategory")

    // Close all subcategories while clicking on a new/the same category
    // eslint-disable-next-line
    function closeSubcategories(category) {
        const categorySubItems = category.querySelectorAll(".help-center__subcategory")
        for (let index = 0; index < categorySubItems.length; index++) {
            // Find subcategory content block with added max-height only (already open)
            const subItemContent = categorySubItems[index].querySelector(".help-center__subcategory-content")
            if (subItemContent && getValueFromPx(subItemContent.style.maxHeight)) {
                handleItemView("subcategory", categorySubItems[index], false, true)
            }
        }
    }

    // Logic for composition of every item closed/open content
    // eslint-disable-next-line
    function handleItemView(itemName, item, open = false, closeAll = false) {
        let head = item.querySelector(`.help-center__${itemName}-head`)
        let content = item.querySelector(`.help-center__${itemName}-content`)
        let contentArrow = item.querySelector(`.help-center__${itemName}-arrow`)

        if (itemName === "subcategory" && !content) return

        // If click to close an item
        if (!open) {
            // Hide padding for subcategory content on item closing
            if (itemName === "subcategory") content.classList.add("padding-top-bottom-none")
            // Delete item content height
            content.style.maxHeight = null
            // Hide margin-top for category item
            if (itemName === "category") content.classList.remove("item-position")
            // Add overflow to item class
            content.classList.add("non-visible")
            // Return item arrow to its default state
            contentArrow.classList.remove("rotated")

            // Handle subcategory max-height deleting, only on the main page
            if (itemName === "subcategory" && !closeAll && categoriesContainer) {
                // Find parent category content block to subtract subcategory height after hiding
                let categoryId = content.closest(".help-center__category").id
                const categoryContent = document.querySelector(`#${categoryId} .help-center__category-content`)
                // Subtraction of hiding subcategory height from category content height
                categoryContent.style.maxHeight = `${
                    categoryContent.getBoundingClientRect().height - content.scrollHeight
                }px`
            }
            // If click to open an item
        } else {
            // All open operations are opposite to hiding
            if (itemName === "subcategory") content.classList.remove("padding-top-bottom-none")
            content.style.maxHeight = content.scrollHeight + "px"
            if (itemName === "category") content.classList.add("item-position")
            setTimeout(() => content.classList.remove("non-visible"), 200)
            contentArrow.classList.add("rotated")

            if (itemName === "subcategory" && categoriesContainer) {
                let categoryId = content.closest(".help-center__category").id
                const categoryContent = document.querySelector(`#${categoryId} .help-center__category-content`)
                // Addition of height of category content + subcategory head + subcategory content
                categoryContent.style.maxHeight = `${
                    categoryContent.getBoundingClientRect().height +
                    head.getBoundingClientRect().height +
                    content.scrollHeight
                }px`
            }
        }
    }

    // eslint-disable-next-line
    function getValueFromPx(string) {
        const result = Number(string.slice(0, -2))
        return result
    }
}

// Article logic
const article = document.querySelector(".help-center__article")
if (article) {
    const articleId = article.dataset.articleId
    const feedbackLink = document.querySelector(".feedback-link")
    const asideButton = document.querySelector(".help-center__article-aside-title")
    const asideIcon = document.querySelector(".help-center__article-aside-icon")
    const asideContent = document.querySelector(".help-center__article-aside-content")
    let isAsideOpen = false
    let isFeedbackSent = false

    // Add event listener on click to aside title
    asideButton.addEventListener("click", () => {
        if (window.innerWidth > $tabletView) return

        asideContent.style.maxHeight ? handleAsideView(true) : handleAsideView()
    })

    // Handle aside open/close logic
    // eslint-disable-next-line
    function handleAsideView(open = false) {
        if (!open) {
            asideButton.classList.add("help-center__article-aside-title_aside-open")
            asideContent.style.maxHeight = asideContent.scrollHeight + "px"
            asideIcon.classList.add("rotated")
            isAsideOpen = true
        } else {
            asideButton.classList.remove("help-center__article-aside-title_aside-open")
            asideContent.style.maxHeight = null
            asideIcon.classList.remove("rotated")
            isAsideOpen = false
        }
    }

    // Close aside panel on wide viewports
    window.addEventListener("resize", () => {
        if (isAsideOpen && window.innerWidth > $tabletView) {
            handleAsideView(true)
        }
    })

    // Close aside panel on click outside
    window.addEventListener("click", event => {
        if (isAsideOpen && window.innerWidth <= $tabletView && !event.target.closest(".help-center__article-aside")) {
            handleAsideView(true)
        }
    })

    // Add help link to feedback window link
    switch (window.app_current_locale) {
        case "en":
            feedbackLink.href = "https://tawk.to/chat/6408f7ae4247f20fefe4c888/1gr1gf0e9"
            break
        case "uk":
            feedbackLink.href = "https://tawk.to/chat/6408f7ae4247f20fefe4c888/1grdq4fdn"
            break
        default:
            feedbackLink.href = "https://tawk.to/chat/6408f7ae4247f20fefe4c888/1grdqn8ph"
            break
    }

    // Send feedback
    const feedbackPositiveBtn = document.querySelector(".feedback-positive")
    const feedbackNegativeBtn = document.querySelector(".feedback-negative")

    if (feedbackPositiveBtn) {
        feedbackPositiveBtn.addEventListener("click", () => sendFeedback(1))
    }

    if (feedbackNegativeBtn) {
        feedbackNegativeBtn.addEventListener("click", () => sendFeedback(0))
    }

    // eslint-disable-next-line
    async function sendFeedback(value) {
        // Prevent feedback from sending second time
        if (isFeedbackSent) return

        const baseURL = "/api/v1"
        const url = `${baseURL}/help-center/article/${articleId}/set-rating`
        const data = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ its_useful: value })
        }
        const response = await fetch(url, data)
        // eslint-disable-next-line
        const result = await response.json()
        isFeedbackSent = true
    }
}

if (moreButton) {
    moreButton.addEventListener("click", () => {
        const aside = document.querySelector(".help-center__article-aside")

        aside.classList.add("help-center__article-aside_visible")
        moreButton.style.display = "none"
    })
}
